import React from 'react';
import { Icon } from './Icon.js';
export const IconDotsVerticalFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("circle", { cx: "9", cy: "9", r: "1.25", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("circle", { cx: "9", cy: "3.25", r: "1.25", fill: "currentColor" }),
        React.createElement("circle", { cx: "9", cy: "14.75", r: "1.25", fill: "currentColor" })));
};
//# sourceMappingURL=IconDotsVerticalFill18.js.map